import { render, staticRenderFns } from "./PatientDisease.vue?vue&type=template&id=ac51da8a&scoped=true&"
import script from "./PatientDisease.vue?vue&type=script&lang=js&"
export * from "./PatientDisease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac51da8a",
  null
  
)

export default component.exports